import { zodResolver } from '@hookform/resolvers/zod';
import { t } from 'i18next';
import { useForm, UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

const TRANS_KEY = 'ARTIST_FORM_FIELDS.FORM_ERRORS';

const formSchema = z.object({
  name: z.string().min(2, { message: t(`artists:${TRANS_KEY}.NAME_REQUIRED`) }),
  abbreviation: z.string().max(4, { message: t(`artists:${TRANS_KEY}.ABBREVIATION_MAX_LENGTH`) }),
  artistLink: z.string(),
  website: z.string(),
  genres: z.array(z.string()),
  isDomesticArtist: z.boolean(),
  isFemaleAct: z.boolean(),
  comment: z.string(),
  defaultOrganizationUnit: z.string().nullable(),
});

export type AddArtistFormSchemaType = z.infer<typeof formSchema>;

const defaultValues: AddArtistFormSchemaType = {
  name: '',
  abbreviation: '',
  artistLink: 'www.prk-dreamhaus.com/talent/',
  website: '',
  genres: [],
  isDomesticArtist: false,
  isFemaleAct: false,
  comment: '',
  defaultOrganizationUnit: null,
};

type UseAddArtistFormReturnType = UseFormReturn<AddArtistFormSchemaType>;

export const useAddArtistForm = (): UseAddArtistFormReturnType => {
  return useForm({
    defaultValues,
    resolver: zodResolver(formSchema),
  });
};
